import { useTransition, animated } from 'react-spring';

import Close from '@popup/components/Close';
import PopupTitle from '@popup/components/PopupTitle';
import Tip from '@popup/components/Tip';
import Button from '@ui/components/Button';
import IconSpinner from '@ui/components/icons/IconSpinner';

export interface SubmitEventProps {
  isShown: boolean;
  isSubmitting: boolean;
  close: () => void;
  onSubmit: () => void;
}

const SubmitEvent = ({
  isShown,
  isSubmitting,
  close,
  onSubmit,
}: SubmitEventProps) => {
  const transition = useTransition(isShown, {
    from: { transform: 'translateY(150%) translateX(-50%)' },
    enter: { transform: 'translateY(0%) translateX(-50%)' },
    leave: { transform: 'translateY(150%) translateX(-50%)' },
  });

  return (
    <>
      {transition(
        (style, item) =>
          item && (
            <animated.div
              style={style}
              className="group/notificationFull fixed bottom-2 left-1/2 z-10 flex w-[calc(100%-16px)] max-w-[880px] -translate-x-1/2 flex-wrap items-center justify-center rounded-[40px] shadow-popup transition-colors duration-300 motion-reduce:transition-none"
            >
              <div className="md:-pb-2 relative flex w-full overflow-hidden rounded-t-[40px] bg-brand-primary-200 pb-[185px] md:h-[178px] md:items-center md:p-6">
                <PopupTitle
                  text="Opravdu chceš akci vytvořit?"
                  className="ml-8 mr-12 mt-12 max-w-[340px] pr-8 md:mr-0 md:mt-0 md:pr-0"
                />
                <Tip text="🤔 Po&nbsp;vytvoření už&nbsp;akci neupravíš" />
                <Close onClick={close} />
              </div>
              <div className="flex h-[136px] w-full items-center justify-center rounded-b-[40px] bg-brand-white-100 py-4 md:py-[60px]">
                <Button
                  className="w-48"
                  size="big"
                  onClick={onSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <IconSpinner /> : 'Vytvořit akci'}
                </Button>
              </div>
            </animated.div>
          ),
      )}
    </>
  );
};

export default SubmitEvent;
